import DialogContent from './DialogContent'

export default DialogContent
export * from './DialogContent.types'
